import { Modal, ModalProps } from 'antd'

import { useLocales } from 'src/locales'

import { InvestigationTestsCard } from './InvestigationTestsCard'

type Props = {
  investigationId: string
  typeId: string
  onCancel: () => void
} & ModalProps

export const InvestigationsTestsModal = ({
  investigationId,
  onCancel,
  typeId,
  ...props
}: Props) => {
  const { t } = useLocales()

  return (
    <Modal
      open
      width={1000}
      onCancel={onCancel}
      maskClosable={false}
      footer={null}
      title={t('specimens.investigation_tests')}
      {...props}
    >
      <InvestigationTestsCard
        investigationId={investigationId}
        typeId={typeId}
      />
    </Modal>
  )
}
